module.exports = __webpack_public_path__ + "img/gif-yvivre.898618c6.gif";